module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/c55628a5359b46566d724090941ab88a.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_livemaths_points.svg
// module id = QcyW
// module chunks = 1